import { DollarSign, Clock, Trophy } from "lucide-react";

const usd = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(n || 0);

export default function SalesSnapshot({ dashboard }) {
  if (!dashboard) {
    return (
      <div className="mb-10 grid md:grid-cols-3 gap-4" data-testid="sales-snapshot-loading">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-28 border border-borderSubtle bg-white animate-pulse"/>
        ))}
      </div>
    );
  }
  const top = dashboard.top_sellers_week || [];
  return (
    <div className="mb-10 grid md:grid-cols-3 gap-4" data-testid="sales-snapshot">
      {/* Today's revenue */}
      <div className="border border-borderSubtle bg-white p-6" data-testid="stat-today-revenue">
        <div className="flex items-center justify-between mb-3">
          <p className="overline">Today · revenue</p>
          <span className="w-8 h-8 rounded-full bg-bone flex items-center justify-center text-charcoal">
            <DollarSign size={14} strokeWidth={2}/>
          </span>
        </div>
        <p className="font-mono text-4xl text-oxblood leading-none">{usd(dashboard.today_revenue)}</p>
        <p className="text-xs text-stone mt-3">{dashboard.today_order_count} order{dashboard.today_order_count === 1 ? "" : "s"} today</p>
      </div>

      {/* Pending payment */}
      <div className="border border-borderSubtle bg-white p-6" data-testid="stat-pending-count">
        <div className="flex items-center justify-between mb-3">
          <p className="overline">Awaiting payment</p>
          <span className="w-8 h-8 rounded-full bg-bone flex items-center justify-center text-charcoal">
            <Clock size={14} strokeWidth={2}/>
          </span>
        </div>
        <p className="font-mono text-4xl text-charcoal leading-none">{dashboard.pending_payment_count}</p>
        <p className="text-xs text-stone mt-3">
          {dashboard.pending_payment_count === 0
            ? "All caught up."
            : "Nudge these buyers to send Venmo/Cash App."}
        </p>
      </div>

      {/* Top 3 sellers this week */}
      <div className="border border-borderSubtle bg-white p-6" data-testid="stat-top-sellers">
        <div className="flex items-center justify-between mb-3">
          <p className="overline">Top sellers · 7d</p>
          <span className="w-8 h-8 rounded-full bg-bone flex items-center justify-center text-charcoal">
            <Trophy size={14} strokeWidth={2}/>
          </span>
        </div>
        {top.length === 0 ? (
          <p className="text-sm text-stone">No sales in the last 7 days.</p>
        ) : (
          <ol className="space-y-1.5" data-testid="top-sellers-list">
            {top.map((t, i) => (
              <li key={t.product_id + i} className="flex items-baseline justify-between gap-3 text-sm">
                <span className="truncate">
                  <span className="font-mono text-stone text-xs mr-2">{i + 1}.</span>
                  {t.name}
                </span>
                <span className="font-mono text-xs text-stone shrink-0">
                  {t.kits_sold} kits · {usd(t.revenue)}
                </span>
              </li>
            ))}
          </ol>
        )}
      </div>
    </div>
  );
}
